export function CustomDashboardSection() {
  return (
    <section id="custom" aria-labelledby="custom-title" className="bg-surface-muted">
      <div className="inner split-grid">
        <figure className="reveal m-0">
          <img
            src="/assets/images/custom-dashboard.png"
            alt="Nova 대시보드 위젯 커스텀 화면"
            width="2513"
            height="1651"
            className="h-auto w-full max-w-[608px]"
            loading="lazy"
          />
        </figure>

        <div className="reveal">
          <img
            src="/assets/icons/custom-main.png"
            alt=""
            aria-hidden="true"
            width="368"
            height="368"
            className="section-icon"
            loading="lazy"
          />
          <h2 id="custom-title" className="heading-2">
            추천 데이터부터
            <br />
            보고싶은 핵심 데이터까지
          </h2>
          <p className="heading-2 mt-8 text-brand-600">내맘대로 자유로운 커스텀</p>
        </div>
      </div>
    </section>
  );
}
